// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ConfirmationModal from "../../../sidebars/ConfirmationModal.bs.js";

function CreateModificationConfirmationModal(Props) {
  var isOpen = Props.isOpen;
  var modification_name = Props.modification_name;
  var campaign_name = Props.campaign_name;
  var onConfirmCb = Props.onConfirmCb;
  var onCancelCb = Props.onCancelCb;
  return React.createElement(ConfirmationModal.make, {
              title: "Create Modification",
              isOpen: isOpen,
              onConfirmCb: onConfirmCb,
              onCancelCb: onCancelCb,
              confirm_button_title: "Yes, Submit",
              cancel_button_title: "No, Cancel",
              children: React.createElement("p", undefined, "You are about to create ", React.createElement("b", undefined, modification_name), " modification under " + (campaign_name + " campaign. Are you sure you wish to continue?"))
            });
}

var make = CreateModificationConfirmationModal;

export {
  make ,
  
}
/* react Not a pure module */
